// @flow

export const API_URL = window.PALANTIR.config.API_URL;
